
export const getProfileMeta = (value, trigger) => {
  const options =
  {
    '1': 'Empresário (dono, sócio, representante, MEI) Empresa com CNPJ.',
    '2': 'Tenho uma empresa mas não tenho CNPJ (não sou formalizado).',
    '3': 'Quero abrir uma empresa mas preciso de ajuda para escolher qual vai ser minha atividade.',
    '4': 'Não tenho empresa mas tenho interesse em aprender sobre empreendedorismo.'
  }

  return { value: options[value], label: options[value], trigger };
}

export const getCompanyDifficulties = () => {
  return [
    { id: "Cooperação", title: 'Cooperação', description: 'Como fazer parcerias que beneficiem o seu negócio, além de orientações para ajudar na gestão da sua empresa.' },
    { id: "Empreendedorismo", title: 'Empreendedorismo', description: 'Desenvolvimento de habilidades empreendedoras e de negociação, empreendedorismo social.' },
    { id: "Finanças", title: 'Finanças', description: 'Diagnóstico e controles financeiros, formação de preço de venda, orientação para crédito.' },
    { id: "Inovação", title: 'Inovação', description: 'Aplicações de soluções digitais e funcionais para melhorar o negócio, segurança da informação.' },
    { id: "Leis", title: 'Leis', description: 'Impostos/taxas, diretos trabalhistas, contratos de sociedade,  abertura e fechamento de empresas.' },
    { id: "Mercado e vendas", title: 'Mercado e vendas', description: 'Marketing digital, pesquisa de perfil e hábitos do consumidor, relacionamento com os clientes.' },
    { id: "Organização", title: 'Organização', description: 'Administração de produtos e insumos, compras, gestão de estoque e fornecedores.' },
    { id: "Pessoas", title: 'Pessoas', description: 'Recrutamento e seleção, desenvolvimento e treinamento de equipes, obrigações trabalhistas.' },
    { id: "Planejamento", title: 'Planejamento', description: 'Diagnóstico empresarial, plano de negócios, estratégias e visão sistêmica do negócio.' },
  ]
}

export const getBusinessAreasOptions = ({ trigger }) => {
  return [
    { value: 'Alimentos e bebidas', label: 'Alimentos e bebidas', trigger },
    { value: 'Artesanato e economia criativa', label: 'Artesanato e economia criativa', trigger },
    { value: 'Beleza e cosméticos', label: 'Beleza e cosméticos', trigger },
    { value: 'Casa e construção', label: 'Casa e construção', trigger },
    { value: 'Economia digital', label: 'Economia digital', trigger },
    { value: 'Energia', label: 'Energia', trigger },
    { value: 'Saúde e bem-estar', label: 'Saúde e bem-estar', trigger },
    { value: 'Transporte e logística', label: 'Transporte e logística', trigger },
    { value: 'Turismo', label: 'Turismo', trigger },
    { value: 'Vestuário e calçados', label: 'Vestuário e calçados', trigger },
    { value: 'Outro', label: 'Outro', trigger }
  ];
}